﻿import { useEffect } from 'react';

import { AccessCodesContext, TransactionDetailsContext } from 'pages/access_codes/context';
import { AccessCodeDetail } from 'pages/access_codes/AccessCodeDetail';
import type { TransactionPermissions } from 'pages/access_codes/types';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { NotificationContextProvider } from 'app/notifications';
import { AccessCodes } from 'pages/access_codes/AccessCodes';
import { TabsContextProvider } from 'components/Tabs/Tabs';
import type { StudentPermissions } from 'pages/students';
import { useIntl } from 'react-intl';

// Tours temporarily disabled
// import { JoyrideContextProvider } from 'app/joyride';
import { DefaultLayout } from 'components/layout';
import { useParams } from 'react-router-dom';
import { PermissionsApi } from 'apis';
import { useSuperState } from 'hooks';

export type AccessCodesContextValue = {
    permissions: TransactionPermissions;
    studentPermissions: StudentPermissions;
}

export const AccessCodesWrapper = () => {

    const { formatMessage } = useIntl();
    const [state, setState] = useSuperState({
        loading: true,
        permissions: null as TransactionPermissions,
        studentPermissions: null as StudentPermissions
    });

    const { loading, permissions, studentPermissions } = state;

    const { id } = useParams();

    const fetchPermissions = async () => {

        try {

            const [permissions, studentPermissions] = await Promise.all([
                PermissionsApi.Get('AccessCode'),
                PermissionsApi.Get('Student')
            ]);

            setState({
                loading: false,
                permissions,
                studentPermissions
            });

        } catch (e) {

            console.error(e);
            setState({ loading: false });

        }

    };

    useEffect(() => {

        fetchPermissions();

    }, []);

    const context: AccessCodesContextValue = {
        permissions,
        studentPermissions
    };

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'access_codes.3114ae04', defaultMessage: 'Access Codes' })}>
            <AccessCodesContext.Provider value={context}>
                <TabsContextProvider disableUrlSync context={TransactionDetailsContext}>
                    {/* Tours temporarily disabled */}
                    {/* <JoyrideContextProvider> */}
                    <NotificationContextProvider>
                        {loading ?
                            (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: 'calc(100vh - 70px)' }}>
                                    <GMetrixLoader />
                                </div>
                            )
                            :
                            (
                                id ? <AccessCodeDetail /> : <AccessCodes />
                            )
                        }
                    </NotificationContextProvider>
                    {/* </JoyrideContextProvider> */}
                </TabsContextProvider>
            </AccessCodesContext.Provider>
        </DefaultLayout>
    );

};